import { Controller } from "@hotwired/stimulus"
import mapboxgl from 'mapbox-gl'

// Connects to data-controller="provider-detail-map"
// Displays a small map with a single marker for a provider's location
export default class extends Controller {
  static targets = ["map"]
  static values = {
    accessToken: String,
    latitude: Number,
    longitude: Number
  }

  connect() {
    if (this.latitudeValue != null && this.longitudeValue != null) {
      requestAnimationFrame(() => this.initializeMap())
    }
  }

  initializeMap() {
    mapboxgl.accessToken = this.accessTokenValue

    try {
      this.map = new mapboxgl.Map({
        container: this.mapTarget,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [this.longitudeValue, this.latitudeValue],
        zoom: 14,
        attributionControl: false,
        interactive: true
      })

      this.map.addControl(new mapboxgl.NavigationControl(), 'top-left')

      this.map.on('load', () => {
        const el = document.createElement('div')
        el.className = 'provider-map-marker'

        new mapboxgl.Marker(el)
          .setLngLat([this.longitudeValue, this.latitudeValue])
          .addTo(this.map)
      })
    } catch (error) {
      console.error("Failed to initialize detail map:", error)
    }
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }
}
